import {
  InputWrapper,
  InputWrapperProps,
  PinInput as MantinePinInput,
  PinInputProps,
} from '@mantine/core'

type Props = PinInputProps & InputWrapperProps

export const PinInput = (props: Props) => {
  const { label, description, error, required, styles, ...restProps } = props

  return (
    <InputWrapper
      label={label}
      description={description}
      error={error}
      required={required}
      styles={{
        label: {
          fontSize: '14px',
          color: '#101828',
        },
      }}
    >
      <MantinePinInput
        {...(restProps as PinInputProps)}
        styles={{ input: { marginTop: '10px' }, ...styles }}
      />
    </InputWrapper>
  )
}
